// extracted by mini-css-extract-plugin
module.exports = {"switch":"_02712f2b3b--switch--CQEnX","indicator":"_02712f2b3b--indicator--kueqN","label":"_02712f2b3b--label--hfzMb"};